module.exports = __webpack_public_path__ + "img/Shield.4bb01fee.svg";